import { createFileRoute, Outlet } from '@tanstack/react-router';

import { authClient } from '@/shared/lib/auth-client';
import { sessionExpiredStore } from '@/shared/lib/session-expired-store';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession();
    if (!session) {
      sessionExpiredStore.setExpired();
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return <Outlet />;
}
